import { ISameCaseMatchedCasesSearchModel, SameCaseSortColumns } from '../../same-cases-admin/manage/useGetSameCasesQuery';
import { UseMutationOptions, useMutation } from 'react-query';

import CheckmateApiClient from '../../../../services/apiClient';
import { HttpResponseError } from '../../../../interfaces/IHttpResponseError';
import { IPagedSortedSearchResponseModel } from '../../../../interfaces/PagedSortedSearch';
import { ISameCaseModel } from '../../../../interfaces/ISameCaseModel';

const _apiClient = new CheckmateApiClient();

export const useGetViewSameCases = (
    reactQueryOptions?: UseMutationOptions<
        IPagedSortedSearchResponseModel<ISameCaseModel, SameCaseSortColumns> | undefined,
        unknown,
        ISameCaseMatchedCasesSearchModel,
        unknown
    >
) => {
    return useMutation({
        mutationFn: async (searchModel: ISameCaseMatchedCasesSearchModel) => {
            const response = await _apiClient.getViewSameCases(searchModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to search case groups');
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
        ...reactQueryOptions,
    });
};
